import React, { useState } from 'react'
import { useGetBusinessID } from '@marketing-milk/frontend'
import { DuplicateCreativeModalProps } from './DuplicateCreativeModal.types'
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from '@material-ui/core'
import { toast } from 'react-toastify'
import { useCreatives } from 'pages/business/creatives/useCreatives'

export function DuplicateCreativeModal({
  creative,
  isVisible,
  onToggle,
}: DuplicateCreativeModalProps) {
  const businessID = useGetBusinessID()
  const [newCreativeName, setNewCreativeName] = useState(creative.name)
  const [error, setError] = useState<Error>()
  const [loading, setLoading] = useState(false)

  const { duplicateCreative, refetch } = useCreatives(businessID)

  if (!isVisible) {
    return null
  }

  async function onDuplicate() {
    if (loading || !newCreativeName.trim()) return

    setError(undefined)
    setLoading(true)
    try {
      await duplicateCreative(creative.id, {
        name: newCreativeName.trim(),
      })
      refetch()
      toast.success('Creative has been duplicated')
      onToggle()
    } catch (e: any) {
      setError(e)
    } finally {
      setLoading(false)
    }
  }

  function onCancel() {
    if (loading) return

    setError(undefined)
    onToggle()
  }

  return (
    <Dialog
      open={isVisible}
      onClose={onCancel}
      aria-labelledby="duplicate-modal-title"
      maxWidth="md"
      fullWidth={true}
    >
      <DialogTitle id="duplicate-modal-title">Duplicate Ad Creative</DialogTitle>
      <DialogContent dividers>
        {error && (
          <DialogContentText color="error" role="alert">
            {error.message}
          </DialogContentText>
        )}
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Ad Name"
          fullWidth
          required
          disabled={loading}
          value={newCreativeName}
          onChange={e => setNewCreativeName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel} disabled={loading}>
          Cancel
        </Button>
        <Button
          onClick={onDuplicate}
          variant="contained"
          color="primary"
          disabled={loading || !newCreativeName.trim()}
          startIcon={loading ? <CircularProgress size={16} color="inherit" /> : undefined}
        >
          {loading ? 'Duplicating…' : 'Duplicate'}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
